import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createPaymentPage } from "../services/create-payment-page";
import { PaymentPageFormData } from "@/pages/payment-pages/types/payment-page";

export function useCreatePaymentPage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: PaymentPageFormData) => createPaymentPage(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["payment-pages"] });
    },
  });
}
